{
    "Monday": "Segunda-feira",
    "Mondayshort": "seg",
    "Tuesday": "Terça-feira",
    "Tuesdayshort": "ter",
    "Wednesday": "Quarta-feira",
    "Wednesdayshort": "qua",
    "Thursday": "Quinta-feira",
    "Thursdayshort": "qui",
    "Friday": "Sexta-feira",
    "Fridayshort": "sex",
    "Saturday": "Sábado",
    "Saturdayshort": "Sentado",
    "Sunday": "Domingo",
    "Sundayshort": "Sol",
    "NAME": "DaysOfTheWeek"
}